













import traceQuery from '~/queries/trace.gql'

export default

	props:
		traceData: Object
		contentMap: Object

	data: ->
		loaded: false
		sectionData: {}

	fetch: ->
		@sectionData = await @$craft.getEntry
			query: traceQuery
			variables:
				section: 'trace'
				type: 'about'
				slug: @contentMap.about

		@loaded = true

	computed:
		block: -> {
			id: @sectionData.id
			componentName: 'blocks-tout-carousel'
			showLines: false
			cards: @sectionData.aboutCarousel
		}

